import updateCSS from 'shared/utils/update-css';


function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}


export function injectSettings(WrappedComponent) {
  class InjectSettings extends React.Component {

    static displayName = `InjectSettings(${getDisplayName(WrappedComponent)})`;

    static contextTypes = {
      appSettings: React.PropTypes.object,
    };

    render() {
      const props = _.assign({}, this.props, {
        appSettings: this.context.appSettings,
      });

      return (
        <WrappedComponent {...props} />
      );
    }
  }

  return InjectSettings;
}

export class SettingsProvider extends React.Component {
  static propTypes = {
    children: React.PropTypes.element.isRequired,
    appSettings: React.PropTypes.object,
  };

  static defaultProps = {
    appSettings: {},
  };

  static childContextTypes = {
    appSettings: React.PropTypes.object,
  };

  getChildContext() {
    return {
      appSettings: this.props.appSettings,
    };
  }

  render() {
    updateCSS(this.props.appSettings);

    return React.Children.only(this.props.children);
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/utils/settings.js